// extracted by mini-css-extract-plugin
export default {"logout_button":"LogoutButton_logout_button__cp4Re"};